module.exports = __webpack_public_path__ + "static/media/viii-ambientworks.3b7c0b4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/viii-ambientworks.mp3
// module id = dd9N
// module chunks = 0